export const FEEDBACK_HMM = 'feedbackHmm';
export const FEEDBACK_JUGGLE = 'feedbackJuggle';
export const FEEDBACK_NOT_FOUND = 'feedbackNotFound';
export const FEEDBACK_POPCORN = 'feedbackPopcorn';
export const FEEDBACK_THINKING = 'feedbackThinking';
